// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Geteilte Styles aller Logistik-Seiten ──
   Logistik-Akzentfarbe als --logistik (definiert in KernteamLayout.css,
   kernteam-only). CI-Eingabe-/Button-/Print-Muster wie im restlichen Portal. */

/* Tages-Tabs */
.logistik-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1.75rem;
}

.logistik-tab {
  background: var(--weiss);
  color: var(--logistik);
  border: 2px solid var(--logistik);
  border-radius: 20px;
  padding: 0.35rem 1rem;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.15rem;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  min-height: auto !important;
}

.logistik-tab:hover {
  background: var(--logistik-hell);
}

.logistik-tab.active {
  background: var(--logistik);
  color: var(--weiss);
}

/* Leerer Zustand */
.logistik-empty {
  color: var(--primary-dark);
  font-family: 'Circular', sans-serif;
  padding: 0.5rem 0;
  font-size: 1rem;
}

.logistik-state-box {
  background: var(--logistik-blass);
  border-left: 4px solid var(--logistik);
  border-radius: 0 10px 10px 0;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  line-height: 1.35;
  margin: 0.85rem 0;
  padding: 0.75rem 0.9rem;
}

.logistik-state-box.error {
  background: #fdf0ee;
  border-left-color: var(--blutorange);
  color: var(--blutorange);
}

.logistik-toolbar {
  display: grid;
  grid-template-columns: minmax(15rem, 1fr) auto;
  gap: 1rem;
  align-items: end;
  margin: 0 0 1rem;
}

.logistik-search-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.logistik-search-field label,
.logistik-panel-label {
  color: var(--logistik);
  font-family: 'Staatliches', sans-serif;
  font-size: 1rem;
  text-transform: uppercase;
}

.logistik-stat-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  justify-content: flex-end;
}

.logistik-stat-pill {
  background: var(--weiss);
  border: 1px solid var(--logistik-hell-hover);
  border-radius: 999px;
  color: var(--logistik);
  font-family: 'Circular', sans-serif;
  font-size: 0.85rem;
  padding: 0.38rem 0.65rem;
  white-space: nowrap;
}

/* Eingabefelder — CI-Muster: durchscheinendes Grün, randlos */
.logistik-input {
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  padding: 10px;
  border: none;
  border-radius: 5px;
  outline: none;
  background-color: rgba(180, 200, 130, 0.5);
  color: var(--dunkelgruen);
  width: 100%;
  box-sizing: border-box;
}

.logistik-input::placeholder {
  color: var(--primary-dark);
  opacity: 1;
}

.logistik-input:focus {
  box-shadow: 0 0 0 2px var(--logistik);
}

.logistik-input[type="number"] {
  width: 5rem;
}

select.logistik-input {
  color: var(--dunkelgruen);
}

/* Aktions-Buttons (Icon-Buttons in Zeilen/Tabellen) */
.logistik-btn {
  min-height: auto !important;
  padding: 0.35rem 0.7rem !important;
  border-radius: 10px !important;
  font-size: 0.9rem !important;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  white-space: nowrap;
  font-family: 'Staatliches', sans-serif !important;
}

.logistik-btn .material-symbols-outlined {
  font-size: 1.1rem !important;
}

.logistik-edit-btn {
  background: var(--logistik-hell) !important;
  color: var(--logistik) !important;
}

.logistik-edit-btn:hover {
  background: var(--logistik-hell-hover) !important;
}

.logistik-edit-btn .material-symbols-outlined,
.logistik-cancel-btn .material-symbols-outlined {
  color: var(--logistik) !important;
}

.logistik-delete-btn {
  background: var(--blutorange) !important;
  color: var(--weiss) !important;
}

.logistik-delete-btn .material-symbols-outlined,
.logistik-save-btn .material-symbols-outlined {
  color: var(--weiss) !important;
}

.logistik-delete-btn:hover {
  background: #d4491d !important;
}

.logistik-save-btn {
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

.logistik-save-btn:hover {
  background: var(--logistik-hover) !important;
}

.logistik-cancel-btn {
  background: transparent !important;
  color: var(--logistik) !important;
  border: 2px solid var(--logistik) !important;
}

.logistik-cancel-btn:hover {
  background: var(--logistik-hell) !important;
}

.logistik-actions {
  display: flex;
  gap: 0.3rem;
  align-items: center;
}

.logistik-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(0, 0, 0, 0.45);
}

.logistik-confirm-dialog {
  width: min(92vw, 24rem);
  background: var(--logistik-blass);
  border: 2px solid var(--logistik);
  border-radius: 16px;
  box-shadow: 0 8px 36px rgba(0, 0, 0, 0.28);
  padding: 1.25rem;
}

.logistik-confirm-dialog h2 {
  color: var(--logistik);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.6rem;
  line-height: 1;
  margin-bottom: 0.65rem;
}

.logistik-confirm-copy,
.logistik-confirm-copy p {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.95rem;
  line-height: 1.35;
}

.logistik-confirm-buttons {
  display: flex;
  gap: 0.65rem;
  margin-top: 1rem;
}

.logistik-confirm-buttons button {
  min-height: auto !important;
  border-radius: 999px !important;
  font-family: 'Staatliches', sans-serif !important;
  font-size: 1rem !important;
  padding: 0.55rem 0.9rem !important;
}

.logistik-confirm-no {
  background: var(--weiss) !important;
  border: 2px solid var(--logistik) !important;
  color: var(--logistik) !important;
}

.logistik-confirm-yes {
  background: var(--blutorange) !important;
  color: var(--weiss) !important;
}

/* Footer */
.logistik-footer {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
  align-items: center;
}

/* Primäre Aktion (Hinzufügen) */
.logistik-add-btn {
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
  padding: 0.7rem 1.3rem !important;
  border-radius: 20px !important;
  font-size: 1.1rem !important;
  min-height: auto !important;
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

.logistik-add-btn:hover {
  background: var(--logistik-hover) !important;
}

.logistik-add-btn .material-symbols-outlined,
.logistik-save-btn .material-symbols-outlined,
.logistik-delete-btn .material-symbols-outlined {
  color: var(--weiss) !important;
}

.logistik-import-btn .material-symbols-outlined {
  color: var(--logistik) !important;
}

/* Sekundäre Aktion (Import) — Outline-Variante */
.logistik-import-btn {
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
  padding: 0.7rem 1.3rem !important;
  border-radius: 20px !important;
  font-size: 1.1rem !important;
  min-height: auto !important;
  background: var(--weiss) !important;
  color: var(--logistik) !important;
  border: 2px solid var(--logistik) !important;
}

.logistik-import-btn:hover {
  background: var(--logistik-hell) !important;
}

/* Drucken — als Text-Link wie im restlichen Portal (.print-link-Muster) */
.logistik-print-link {
  background: none !important;
  border: none !important;
  min-height: auto !important;
  padding: 0 !important;
  margin-left: auto;
  color: var(--mittelblau) !important;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-family: 'Circular', sans-serif !important;
  text-transform: none !important;
  font-size: 1rem;
}

.logistik-print-link .print-text {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.logistik-print-link .material-symbols-outlined {
  font-variation-settings: 'FILL' 0, 'wght' 500, 'GRAD' 0, 'opsz' 40;
}

/* Druckansicht */
.only-print {
  display: none;
}

@media print {
  .no-print {
    display: none !important;
  }

  .only-print {
    display: block !important;
  }

  body {
    background: var(--weiss) !important;
  }

  .print-day-title {
    font-family: 'Staatliches', sans-serif;
    font-size: 2rem;
    color: var(--logistik);
    margin-bottom: 1rem;
    text-transform: uppercase;
  }
}

@media (max-width: 700px) {
  .logistik-toolbar {
    grid-template-columns: 1fr;
  }

  .logistik-stat-strip {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/logistik/logistik-base.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,iDAAiD;EACjD,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iDAAiD;AACjD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,0EAA0E;AAC1E;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,kEAAkE;AACpE;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ── Geteilte Styles aller Logistik-Seiten ──\n   Logistik-Akzentfarbe als --logistik (definiert in KernteamLayout.css,\n   kernteam-only). CI-Eingabe-/Button-/Print-Muster wie im restlichen Portal. */\n\n/* Tages-Tabs */\n.logistik-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1.75rem;\n}\n\n.logistik-tab {\n  background: var(--weiss);\n  color: var(--logistik);\n  border: 2px solid var(--logistik);\n  border-radius: 20px;\n  padding: 0.35rem 1rem;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.15rem;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  min-height: auto !important;\n}\n\n.logistik-tab:hover {\n  background: var(--logistik-hell);\n}\n\n.logistik-tab.active {\n  background: var(--logistik);\n  color: var(--weiss);\n}\n\n/* Leerer Zustand */\n.logistik-empty {\n  color: var(--primary-dark);\n  font-family: 'Circular', sans-serif;\n  padding: 0.5rem 0;\n  font-size: 1rem;\n}\n\n.logistik-state-box {\n  background: var(--logistik-blass);\n  border-left: 4px solid var(--logistik);\n  border-radius: 0 10px 10px 0;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  line-height: 1.35;\n  margin: 0.85rem 0;\n  padding: 0.75rem 0.9rem;\n}\n\n.logistik-state-box.error {\n  background: #fdf0ee;\n  border-left-color: var(--blutorange);\n  color: var(--blutorange);\n}\n\n.logistik-toolbar {\n  display: grid;\n  grid-template-columns: minmax(15rem, 1fr) auto;\n  gap: 1rem;\n  align-items: end;\n  margin: 0 0 1rem;\n}\n\n.logistik-search-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.logistik-search-field label,\n.logistik-panel-label {\n  color: var(--logistik);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1rem;\n  text-transform: uppercase;\n}\n\n.logistik-stat-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  justify-content: flex-end;\n}\n\n.logistik-stat-pill {\n  background: var(--weiss);\n  border: 1px solid var(--logistik-hell-hover);\n  border-radius: 999px;\n  color: var(--logistik);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.85rem;\n  padding: 0.38rem 0.65rem;\n  white-space: nowrap;\n}\n\n/* Eingabefelder — CI-Muster: durchscheinendes Grün, randlos */\n.logistik-input {\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  outline: none;\n  background-color: rgba(180, 200, 130, 0.5);\n  color: var(--dunkelgruen);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.logistik-input::placeholder {\n  color: var(--primary-dark);\n  opacity: 1;\n}\n\n.logistik-input:focus {\n  box-shadow: 0 0 0 2px var(--logistik);\n}\n\n.logistik-input[type=\"number\"] {\n  width: 5rem;\n}\n\nselect.logistik-input {\n  color: var(--dunkelgruen);\n}\n\n/* Aktions-Buttons (Icon-Buttons in Zeilen/Tabellen) */\n.logistik-btn {\n  min-height: auto !important;\n  padding: 0.35rem 0.7rem !important;\n  border-radius: 10px !important;\n  font-size: 0.9rem !important;\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  white-space: nowrap;\n  font-family: 'Staatliches', sans-serif !important;\n}\n\n.logistik-btn .material-symbols-outlined {\n  font-size: 1.1rem !important;\n}\n\n.logistik-edit-btn {\n  background: var(--logistik-hell) !important;\n  color: var(--logistik) !important;\n}\n\n.logistik-edit-btn:hover {\n  background: var(--logistik-hell-hover) !important;\n}\n\n.logistik-edit-btn .material-symbols-outlined,\n.logistik-cancel-btn .material-symbols-outlined {\n  color: var(--logistik) !important;\n}\n\n.logistik-delete-btn {\n  background: var(--blutorange) !important;\n  color: var(--weiss) !important;\n}\n\n.logistik-delete-btn .material-symbols-outlined,\n.logistik-save-btn .material-symbols-outlined {\n  color: var(--weiss) !important;\n}\n\n.logistik-delete-btn:hover {\n  background: #d4491d !important;\n}\n\n.logistik-save-btn {\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.logistik-save-btn:hover {\n  background: var(--logistik-hover) !important;\n}\n\n.logistik-cancel-btn {\n  background: transparent !important;\n  color: var(--logistik) !important;\n  border: 2px solid var(--logistik) !important;\n}\n\n.logistik-cancel-btn:hover {\n  background: var(--logistik-hell) !important;\n}\n\n.logistik-actions {\n  display: flex;\n  gap: 0.3rem;\n  align-items: center;\n}\n\n.logistik-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.logistik-confirm-dialog {\n  width: min(92vw, 24rem);\n  background: var(--logistik-blass);\n  border: 2px solid var(--logistik);\n  border-radius: 16px;\n  box-shadow: 0 8px 36px rgba(0, 0, 0, 0.28);\n  padding: 1.25rem;\n}\n\n.logistik-confirm-dialog h2 {\n  color: var(--logistik);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.6rem;\n  line-height: 1;\n  margin-bottom: 0.65rem;\n}\n\n.logistik-confirm-copy,\n.logistik-confirm-copy p {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.35;\n}\n\n.logistik-confirm-buttons {\n  display: flex;\n  gap: 0.65rem;\n  margin-top: 1rem;\n}\n\n.logistik-confirm-buttons button {\n  min-height: auto !important;\n  border-radius: 999px !important;\n  font-family: 'Staatliches', sans-serif !important;\n  font-size: 1rem !important;\n  padding: 0.55rem 0.9rem !important;\n}\n\n.logistik-confirm-no {\n  background: var(--weiss) !important;\n  border: 2px solid var(--logistik) !important;\n  color: var(--logistik) !important;\n}\n\n.logistik-confirm-yes {\n  background: var(--blutorange) !important;\n  color: var(--weiss) !important;\n}\n\n/* Footer */\n.logistik-footer {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* Primäre Aktion (Hinzufügen) */\n.logistik-add-btn {\n  display: flex !important;\n  align-items: center !important;\n  gap: 0.5rem !important;\n  padding: 0.7rem 1.3rem !important;\n  border-radius: 20px !important;\n  font-size: 1.1rem !important;\n  min-height: auto !important;\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.logistik-add-btn:hover {\n  background: var(--logistik-hover) !important;\n}\n\n.logistik-add-btn .material-symbols-outlined,\n.logistik-save-btn .material-symbols-outlined,\n.logistik-delete-btn .material-symbols-outlined {\n  color: var(--weiss) !important;\n}\n\n.logistik-import-btn .material-symbols-outlined {\n  color: var(--logistik) !important;\n}\n\n/* Sekundäre Aktion (Import) — Outline-Variante */\n.logistik-import-btn {\n  display: flex !important;\n  align-items: center !important;\n  gap: 0.5rem !important;\n  padding: 0.7rem 1.3rem !important;\n  border-radius: 20px !important;\n  font-size: 1.1rem !important;\n  min-height: auto !important;\n  background: var(--weiss) !important;\n  color: var(--logistik) !important;\n  border: 2px solid var(--logistik) !important;\n}\n\n.logistik-import-btn:hover {\n  background: var(--logistik-hell) !important;\n}\n\n/* Drucken — als Text-Link wie im restlichen Portal (.print-link-Muster) */\n.logistik-print-link {\n  background: none !important;\n  border: none !important;\n  min-height: auto !important;\n  padding: 0 !important;\n  margin-left: auto;\n  color: var(--mittelblau) !important;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-family: 'Circular', sans-serif !important;\n  text-transform: none !important;\n  font-size: 1rem;\n}\n\n.logistik-print-link .print-text {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.logistik-print-link .material-symbols-outlined {\n  font-variation-settings: 'FILL' 0, 'wght' 500, 'GRAD' 0, 'opsz' 40;\n}\n\n/* Druckansicht */\n.only-print {\n  display: none;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .only-print {\n    display: block !important;\n  }\n\n  body {\n    background: var(--weiss) !important;\n  }\n\n  .print-day-title {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 2rem;\n    color: var(--logistik);\n    margin-bottom: 1rem;\n    text-transform: uppercase;\n  }\n}\n\n@media (max-width: 700px) {\n  .logistik-toolbar {\n    grid-template-columns: 1fr;\n  }\n\n  .logistik-stat-strip {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
